import React from 'react'
import { Copyrights, KoFi, Social } from '../../components/common'
import "./Footer.css"
const Footer = () => {
    return (
        <>
            <KoFi />
            <Social />
            <Copyrights />
        </>
    )
}
export default Footer